










import { defineComponent } from "@vue/composition-api"
import "@/assets/fonts/iconfont"

export default defineComponent({
  props: {
    type: {
      type: String,
      default: "",
    },
    width: {
      type: [String, Number],
      default: "",
    },
    height: {
      type: [String, Number],
      default: "",
    },
  },
  setup() {
    return {}
  },
})
